var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox"},[_c('div',{staticClass:"main-wrapper"},[_c('componentheader'),_c('inboxsidebar'),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"content container-fluid"},[_c('headerinbox'),_c('inboxcontent')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }